import React from 'react'
import { Link } from 'react-router'
import styles from './_homeHeader.css'
import { FormattedMessage } from 'react-intl'

export default function HomeHeader () {
  // Applying a CSS modules class with the react-router activeClassName prop is not working.
  // Manually adding the styles with the activeStyle prop.
  const ACTIVE = {
    boxShadow: 'inset 0 3px 0 0px #2F98D9',
    background: '#FFFFFF',
    color: '#444444',
  }

  return (
    <div>
      <div className={styles.tabsContainer}>
        <Link
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/my_home'>
          <FormattedMessage id='home.tab.activityfeed' defaultMessage='Activity Feed' />
        </Link>

        <Link
          className={styles.tab}
          activeStyle={ACTIVE}
          to='/my_home/dashboard'>
          <FormattedMessage id='home.tab.dashboard' defaultMessage='My Dashboard' />
        </Link>
      </div>
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/home/HomeHeader.jsx